// 静态常量
export const CODE_SUCCESS = 200; // 接口请求成功的code值

// 空状态类型的枚举
export const EMPTY_ENUM = {
  404: "https://zhidao.zdagriiot.com/image/EmptyPNG/404.png", // 网络错误 - 前端报错
  500: "https://zhidao.zdagriiot.com/image/EmptyPNG/500.png", // 服务器异常 - 后端报错
  addressEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/addressEmpty.png", // 未添加收货地址
  collectEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/collectEmpty.png", // 暂无收藏
  loadingError: "https://zhidao.zdagriiot.com/image/EmptyPNG/loadingError.png", // 加载失败
  messageEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/messageEmpty.png", // 暂无消息
  noAddress: "https://zhidao.zdagriiot.com/image/EmptyPNG/noAddress.png", // 暂无地址
  noPersision: "https://zhidao.zdagriiot.com/image/EmptyPNG/noPersision.png", // 暂无权限
  noWifi: "https://zhidao.zdagriiot.com/image/EmptyPNG/noWifi.png", // 网络故障
  orderEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/orderEmpty.png", // 没有订单
  pageEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/pageEmpty.png", // 未找到访问页面
  searchEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/searchEmpty.png", // 未找到相关搜索内容
  shopEmpty: "https://zhidao.zdagriiot.com/image/EmptyPNG/shopEmpty.png", // 购物车
};

// 传感器对应icon图标枚举
export const SENSOR_ICON = {
  Zaosheng: "c-icon-zaosheng", // 噪声
  Shidu: "c-icon-shidu", // 空气湿度
  Wendu: "c-icon-wendu", // 空气温度
  Liangdu: "c-icon-guangzhaodu", // 光照度
  FengSu: "c-icon-fengsu", // 风速
  Fengxiang: "c-icon-fengxiang", // 风向
  TRShidu: "c-icon-turangshidu", // 土壤湿度
  TRWendu: "c-icon-turangwendu", // 土壤温度
  YuShui: "c-icon-liuyumianyuliang", // 雨量
  Co2: "c-icon-eryanghuatan", // 二氧化碳
  TRSJxing: "c-icon-turangpH", // 土壤PH(土壤酸碱性)
  TRDdao: "c-icon-turangEC", // 土壤EC(土壤电导性)
  TRDan: "c-icon-turangdan", // 土壤氮含量
  TRLin: "c-icon-turanglin", // 土壤磷含量
  TRJia: "c-icon-turangjia", // 土壤钾含量
  RZShiJian: "c-icon-rizhaoshishu", // 日照时间
  DQYli: "c-icon-daqiya", // 大气压力
  Yuxue: "c-icon-yuxue1-copy-copy", // 雨雪
  ZWxian: "c-icon-ziwaixianxiaodu", // 紫外线
  GZZFushe: "c-icon-guangheyouxiaofushe_mian", // 光照总辐射
  LJyuliang: "c-icon-yuliangtongji", // 累积雨量
  PM25: "c-icon-a-PM25", // PM2.5
  PM10: "c-icon-PM", // PM10
  ZFliang: "c-icon-zhengfaliang", // 蒸发量
  ShuiZhiPH: "c-icon-shuizhipH", // 水质PH(水质酸碱性)
  ShuiZhiEC: "c-icon-shuizhiEC", // 水质EC(水质电导性)
  ShuiWen: "c-icon-shuiwen", // 水温
  YeWei: "c-icon-yewei", // 液位
  LJliuliang: "c-icon-leijiliuliang", // 累计流量
  SSliuliang: "c-icon-shunshiliuliang", // 瞬时流量
  HEliuliang: "c-icon-huoerliuliang", // 霍尔流量
  WaterPressure: "c-icon-guandaoyali", // 管道压力
};

// 国际化 - 语言切换
export const LANGUAGE_LIST = [
  { label: "简体中文", value: "zh-CN" },
  { label: "English", value: "en" },
];
